import React from "react";
import { Navigate } from "react-router-dom";
import { getUserData } from "../../../common";

const Authmiddleware = (props) => {
  if (!getUserData()) {
    return (
      <Navigate to={{ pathname: "/sign-in" }} />
    );
  }
  return (
    <React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
